import Footer from '../../components/Footer/Footer';
import Header from '../../components/Header/Header';
import React, { useState, useEffect, useRef} from 'react';
import './Profile.css'
import { useNavigate } from 'react-router-dom';
import { fetchProducer } from '../../services/api';
import FaqNav from "../../components/FAQ/FaqNav";
import Toast from "../../components/Toast/Toast";
import {useSearchParams } from 'react-router-dom';
import { format } from 'date-fns';
import { downloadFile } from '../../services/GenericAPI';
import { useLanguage } from '../../context/Languagecontext';
import FallBackLabel from '../../global/Globals_Eng.json';

const CompanyProfile= () => {
   const { Globals ,languages, setLanguages } = useLanguage();
    const [searchParams, setSearchParams] = useSearchParams();
    const [showSuccessToast, setShowSuccessToast] = useState(false);
    const [bbbeeeDetails, setBBBEEDetails]=useState({name:'', downloadPath:''});
    const [taxDetails, setTaxDetails]=useState({name:'', downloadPath:''});
  const [logoDetails, setLogoDetails] = useState({ name: '', downloadPath: '' });
  const [vat103, setVat103Details] = useState({ name: '', downloadPath: '' });
  const [taxInvoice, setTaxInvoiceDetails] = useState({ name: '', downloadPath: '' });
  const [regDocs, setRegDocsDetails] = useState({ name: '', downloadPath: '' });
  const [bankStamped, setBankStampedDetails] = useState({ name: '', downloadPath: '' });
  const [isDocDownloading, setIsDocDownloading] = useState({
    taxFile: false,
    bbbeeFile: false,
    vat103: false,
    taxInvoice: false,
    regDocs: false,
    bankStamped: false
  })
    const [logoSource, setLogoSource]=useState('');
    const [isDownloading, setIsDownloading]=useState(false);
    const [isBBBEEDownloading, setIsBBBEEDownloading]=useState(false);
    const [StoredDocuments, setStoredDocuments]=useState('');
  const [formData, setFormData] = useState({
    producer: {
        producerType: '' 
    },
    companyName: '',
    companyRegNo: '',
    title: '',
    name: '',
    email:"",
    website: '',
    socialMediaLinks:"",
    productionType: '',
    vatRegistrationNumber:"",
    isTaxClearanceCertificate: false,
    isApprovedByAuth: false,
    taxClearanceCertPin:"",
    isBBBEE:false,
    isVendorRegistered:false,
    companyContactNumber:"",
    businessAddress:"",
    companyEmail:"",
    declarationOfInfo:"",
    countryName:"",
    provinceName:"",
    isApproved:true,
    isActive: false,
    languages: [],
    channels: [],
    producerFormat:[],
    genres: [],
    productionTypes: [],
    formats: [],
    vendorRegistrationNumber: '',
    
});
const fetchProducerData = async () => {
 try {
     const data = await fetchProducer();
 
     if (!data || !data.content || !data.content.producer) {
       console.error("Invalid data structure received from API:", data);
       return;
     }
   const documents = data?.content?.documents;
   setStoredDocuments(documents);

    const getDocumentDetails = (documentFor) => {
      const document = documents.find(file => file.documentFor === documentFor);
      return document ? { name: document.documentName.trim(), downloadPath: document.documentPath.trim() } : {};
    };

    setBBBEEDetails(getDocumentDetails('PBBBEE'));
    setTaxDetails(getDocumentDetails('PTAXCLR'));
    setLogoDetails(getDocumentDetails('PLOGO'));
   setBankStampedDetails(getDocumentDetails('CBankDoc'));
   setVat103Details(getDocumentDetails('CVatDoc'));
   setTaxInvoiceDetails(getDocumentDetails('CTaxInv'));
   setRegDocsDetails(getDocumentDetails('CRegDoc'));
     const producer = data.content.producer;
     const languages = data.content.languages || [];
     const socialMediaArray = producer.socialMediaLinks
     ? producer.socialMediaLinks.split(',').map(link => link.trim()): [];
     setFormData({
       producerId: producer.producerId || "",
       producerType: producer.producerType || "Individual",
       companyName: producer.companyName || "",
       companyRegNo: producer.companyRegNo || "",
       title: producer.title || "",
       name: producer.name || "",
       email: producer.email || "",
       website: producer.website || "",
       productionType: producer.productionType || "",
       vatRegistrationNumber: producer.vatRegistrationNumber || "",
       isTaxClearanceCertificate: producer.isTaxClearanceCertificate || '',
       taxClearanceCertExpiryDate: producer.taxClearanceCertExpiryDate || "",
       taxClearanceCertPin: producer.taxClearanceCertPin || "",
       isBBBEE: producer.isBBBEE || '',
       companyContactNumber: producer.companyContactNumber || "",
       provinceName: producer.provinceName || "",
       countryName: producer.countryName || "",
       businessAddress: producer.businessAddress || "",
       companyEmail: producer.companyEmail || "",
       isVendorRegistered: producer.isVendorRegistered || false,
       producer: producer.producer || '', 
       languages: data.content.languages || []  ,   
       genres: data.content.genres || [] ,
       producerFormat: data.content.producerFormat || [] ,
       channels: data.content.channels || [],
       productionTypes: data.content.productionTypes || [],
       socialMediaLinks: socialMediaArray,
       formats: data.content.formats,
       vendorRegistrationNumber: producer.vendorRegistrationNumber || "",
      });
   } catch (error) {
       console.error('Error fetching producer data:', error);
   }
 }
useEffect(() => {
  fetchProducerData();
}, []);
  const navigate = useNavigate()

  const handleEdit = () => {
    navigate('/edit-company')
  };

 useEffect(() => {
    if (searchParams.get('updatedSuccessfully') === 'true') {
      setShowSuccessToast(true);
      navigate({ search: '' });
    }
  }, [searchParams, navigate]);

  useEffect(() => {
    if (showSuccessToast) {
      const timeoutId = setTimeout(() => {
        setShowSuccessToast(false);
      }, 4000);
      return () => clearTimeout(timeoutId);
    }
  }, [showSuccessToast]);
  
  const handleToastClose = () => {
      setShowSuccessToast(false);
  };

  const NavLinkData= {FirstNavbar:Globals.PRODUCER.DASHBOARD,SecondNavbar:Globals.COMPANY_PROFILE,Title:Globals.COMPANY_PROFILE}

  //This finction is to show the downloading status of the files
  const showDownloadingStatus=(fieldName, statusName)=>{
    if (fieldName === 'taxFile' && statusName === 'start') {
      setIsDownloading(true);
    }
    else if(fieldName==='bbbeeFile' && statusName === 'start'){
      setIsBBBEEDownloading(true);
    }
    else if( fieldName === 'vat103' && statusName === 'start'){
      setIsDocDownloading(prevState => ({ ...prevState, vat103: true }));
    }
    else if( fieldName === 'taxInvoice' && statusName === 'start'){
      setIsDocDownloading(prevState => ({ ...prevState, taxInvoice: true }));
    }
    else if( fieldName === 'regDocs' && statusName === 'start'){
      setIsDocDownloading(prevState => ({ ...prevState, regDocs: true }));
    }
    else if( fieldName === 'bankStamped' && statusName === 'start'){
      setIsDocDownloading(prevState => ({ ...prevState, bankStamped: true }));
    }
    else if (fieldName === 'taxFile' && statusName === 'end') {
      setIsDownloading(false);
    }
    else if(fieldName==='bbbeeFile' && statusName === 'end'){
      setIsBBBEEDownloading(false);
    }
    else if( fieldName === 'vat103' && statusName === 'end'){
      setIsDocDownloading(prevState => ({ ...prevState, vat103: false }));
    }
    else if( fieldName === 'taxInvoice' && statusName === 'end'){
      setIsDocDownloading(prevState => ({ ...prevState, taxInvoice: false }));
    }
    else if( fieldName === 'regDocs' && statusName === 'end'){
      setIsDocDownloading(prevState => ({ ...prevState, regDocs: false }));
    }
    else if( fieldName === 'bankStamped' && statusName === 'end'){
      setIsDocDownloading(prevState => ({ ...prevState, bankStamped: false }));
    }
  }
  const downloadSelectedFile = (filePath,fileName,fieldName) => {
    //fieldName==='taxFile'?setIsDownloading(true):setIsBBBEEDownloading(true);
    showDownloadingStatus(fieldName, 'start');
    const isForProducer=true;
    downloadFile(filePath,isForProducer)
      .then((response) => {
        //fieldName==='taxFile'?setIsDownloading(false):setIsBBBEEDownloading(false);
        showDownloadingStatus(fieldName, 'end');
        if (response?.data) {
          const blob = new Blob([response.data]);
          const fileUrl = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = fileUrl;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          // Cleanup
          document.body.removeChild(link);
          window.URL.revokeObjectURL(fileUrl);
        } else {
          //fieldName==='taxFile'?setIsDownloading(false):setIsBBBEEDownloading(false);
          showDownloadingStatus(fieldName, 'end');
          console.error("Error: No file data available for download.");
        }
      })
      .catch((error) => {
        //fieldName==='taxFile'?setIsDownloading(false):setIsBBBEEDownloading(false);
        showDownloadingStatus(fieldName, 'end');
        console.error("Error in downloading the file:", error);
      });
  }
  const getLogoSource = async () => {
    try {
      const isForProducer = true;
      const response = await downloadFile(logoDetails.downloadPath, isForProducer);
      if (response?.data) {
        const blob = new Blob([response.data],{ type: response.headers['Content-Type'] }); 
        const fileUrl = URL.createObjectURL(blob);
        setLogoSource(fileUrl);
        setTimeout(() => URL.revokeObjectURL(fileUrl), 5000);
      } else {
        console.error("Error: No file data available for download.");
      }
    } catch (error) {
      console.error("Error in downloading the file:", error);
    }
  };
  useEffect(()=>{
    if(logoDetails.downloadPath){
      getLogoSource();
    }
  },[logoDetails.downloadPath])

/**
 * File display related
 */
const textRef = useRef(null);
  const [marginLeft, setMarginLeft] = useState(2); // Default spacing

  useEffect(() => {
    if (textRef.current) {
      const textWidth = textRef.current.offsetWidth;
      const spacing = Math.min(20, Math.max(5, textWidth * 0.1)); // Dynamic spacing range
      setMarginLeft(spacing);
    }
  }, [taxDetails.name]);

  useEffect(() => {
    fetchProducerData();
  }, [languages]);

  return (
  <div className="Background-Page">
     <Header />
     <div className='main-head'>
     <div className='nav-element'>
     <FaqNav props={NavLinkData}/>
     <div className="info-item-edit">
    <div className="edit-container back" onClick={handleEdit}>
      <img className="edit-icon" src={Globals.IMG.EDIT} alt="edit"  />
      <span className="edit-text">{Globals.HALF_PAGE_BRIEF_DETAILS.EDIT_BUTTON_TEXT}</span>
    </div></div>
  </div></div>
  <div className='profile-container'>
    <div className="main-profile">
    <div className="profile-page-wrapper">
             <div className='profile-pic-container'>
              <img src={logoSource  || Globals.IMG.PROFILE_BIG} alt="Profile" className="profile-photo" /> 
             </div>
             <div className="profile-page-details"> 
             <span className="profile-page-company">{formData.companyName}</span>
             <span className="profile-page-name">{formData.title && formData.title.trim() !== "" ? formData.title.trim().replace(/([^.])$/, '$1.') + " " + formData.name : formData.name}
</span>      <span className="profile-page-email">{formData.email}</span>
              </div> </div><hr style={{ margin: '10px 24px 24px 24px'}} />
              <div className='main-container'>
  <ul>
    <li>
    <h5 class="custom-margin">{Globals.SIGNUP.COMPANY_INFO}</h5>
      <div className="info-item">
        <h6 className='custom-font'>{Globals.SIGNUP.COMPANY_REG_NUMBER_LABEL}</h6>
        <span className='custom-data'>{formData.companyRegNo || Globals.HALF_PAGE_BRIEF_DETAILS.NA}</span>
      </div>
      <div className="info-item">
      <h6 className="custom-font">{Globals.SIGNUP.GENRE}</h6>
      {formData.genres && formData.genres.length > 0 ? (
        <div>
          {formData.genres.reduce((rows, genre, index) => {
            if (index % 2 === 0) {
              rows.push([]);
            }
            rows[rows.length - 1].push(genre);
            return rows;
          }, []).map((row, rowIndex) => (
            <div key={rowIndex}>
              {row.map((genre, genreIndex) => (
                <span key={genre.genreId}>
                  {genre.genreName || Globals.HALF_PAGE_BRIEF_DETAILS.NA}
                  {/* {genreIndex < row.length - 1 ? ", " : " "} */}
                  {formData.genres.indexOf(genre) < formData.genres.length - 1 ? ", " : " "}
                </span>
              ))}
              <br />
            </div>
          ))}
        </div>
      ) : (
        <span>{Globals.HALF_PAGE_BRIEF_DETAILS.NA}</span>
      )}
    </div>
    <div className="info-item">
  <h6 className='custom-font'>{Globals.SIGNUP.LANGUAGE}</h6>
  {formData.languages.length > 0 ? (
    <div>
      {formData.languages.reduce((rows, language, index) => {
        if (index % 2 === 0) {
          rows.push([]);
        }
        rows[rows.length - 1].push(language);
        return rows;
      }, []).map((row, rowIndex) => (
        <div key={rowIndex}>
          {row.map((language, languageIndex) => (
            <span key={language.languageId}>
              {language.languageName || Globals.HALF_PAGE_BRIEF_DETAILS.NA}
              {formData.languages.indexOf(language) < formData.languages.length - 1 ? ", " : " "}
            </span>
          ))}
          <br />
        </div>
      ))}
    </div>
  ) : (
    <span>{Globals.HALF_PAGE_BRIEF_DETAILS.NA}</span>
  )}
</div>
    <div className="info-item">
      <h6 className='custom-font'>{Globals.SIGNUP.FORMAT_LABEL}</h6>
{Array.isArray(formData.formats) && formData.formats.length > 0 ? (
    <ul>
        {formData.formats.map((formats) => (
            <li key={formats.formatId}>
                {formats.formatName || Globals.HALF_PAGE_BRIEF_DETAILS.NA}
                 {formData.formats.indexOf(formats) < formData.formats.length - 1 ? ", " : " "}
            </li>
        ))}
    </ul>
) : (
    <span className='custom-data'>{Globals.HALF_PAGE_BRIEF_DETAILS.NA}</span>
)}
      </div>
    </li>
    <li>
    <div className="info-item">
  <h6 className='custom-font'>{Globals.SIGNUP.PRODUCTION_TYPE_LABEL}</h6>
  {Array.isArray(formData.productionTypes) && formData.productionTypes.length > 0 ? (
    <div>
      {formData.productionTypes.reduce((rows, format, index) => {
        if (index % 2 === 0) {
          rows.push([]);
        }
        rows[rows.length - 1].push(format);
        return rows;
      }, []).map((row, rowIndex) => (
        <div key={rowIndex}>
          {row.map((format, formatIndex) => (
            <span key={format.productionTypeId}>
              {format.productionTypeName || Globals.HALF_PAGE_BRIEF_DETAILS.NA}
              {/* {formatIndex < row.length - 1 ? ", " : " "} */}
              {formData.productionTypes.indexOf(format) < formData.productionTypes.length - 1 ? ", " : " "}
            </span>
          ))}
          <br />
        </div>
      ))}
    </div>
  ) : (
    <span className='custom-data'>{Globals.HALF_PAGE_BRIEF_DETAILS.NA}</span>
  )}
</div>
      <div className="info-item">
  <h6 className='custom-font'>{Globals.SIGNUP.CHANNELS}</h6>
  {formData.channels.length > 0 ? (
    <div>
      {formData.channels.reduce((rows, channel, index) => {
        if (index % 2 === 0) {
          rows.push([]);
        }
        rows[rows.length - 1].push(channel);
        return rows;
      }, []).map((row, rowIndex) => (
        <div key={rowIndex}>
          {row.map((channel, channelIndex) => (
            <span key={channel.channelId}>
              {channel.channelName || Globals.HALF_PAGE_BRIEF_DETAILS.NA}
              {/* {channelIndex < row.length - 1 ? ", " : " "} */}
              {formData.channels.indexOf(channel) < formData.channels.length - 1 ? ", " : " "}
            </span>
          ))}
          <br />
        </div>
      ))}
    </div>
  ) : (
    <span>{Globals.HALF_PAGE_BRIEF_DETAILS.NA}</span>
  )}
</div>
<div className="info-item">
  <h6 className='custom-font'>{Globals.SIGNUP.WEBSITE}</h6>
  {formData.website ? (
    formData.website.split(",").map((website, index, array) => {
      const trimmedWebsite = website.trim();
      const websiteVariableName = Globals.WEBSITE_LINK;
      const firstLineCount = 2;
      return (
        <div key={index} className="website-link">
          <a
            // href={trimmedWebsite}
            href={trimmedWebsite.startsWith('http://') || trimmedWebsite.startsWith('https://') ? trimmedWebsite : `http://${trimmedWebsite}`}
            alt={websiteVariableName}
            target="_blank"
            rel="noopener noreferrer"
            className="link-value"
          >
            {websiteVariableName}
          </a>
          {index < firstLineCount - 1 && index < array.length - 1 && (
            <span className="separator">, </span>
          )}
          {index === firstLineCount - 1 && <br />}
        </div>
      );
    })
  ) : (
    <span >{Globals.HALF_PAGE_BRIEF_DETAILS.NA}</span>
  )}
</div>
     <div className="info-item">
  <h6 className='custom-font'>{Globals.SIGNUP.SOCIAL_MEDIA}</h6>
  {Array.isArray(formData.socialMediaLinks) && formData.socialMediaLinks.length > 0 && formData.socialMediaLinks.some(link => link.trim() !== "") ? (
    formData.socialMediaLinks
      .filter(link => link.trim() !== "") 
      .map((website, index) => {
      const websiteLabel = `${Globals.SOCIAL_MEDIA} ${index + 1}`; 
      return (
        <div key={index} className="website-link">
          <a
            // href={website}
            href={website.startsWith('http://') || website.startsWith('https://') ? website : `http://${website}`}
            alt={websiteLabel} 
            target="_blank"
            rel="noopener noreferrer"
            className="link-value"
          >
            {websiteLabel}
          </a>
          {index < formData.socialMediaLinks.length - 1 && (
            <span className="separator">, </span>
          )}
        </div>
      );
    })
  ) : (
    <p>{Globals.SIGNUP.SOCIAL_MEDIA}</p>
  )}
</div>
    </li>
  </ul>
  <hr style={{ margin: '24px 24px 24px 0px'}} />
<div className="statutory-info">
  <h5 className="custom-margin">{Globals.SIGNUP.SATUTORY_INFO_LABEL}</h5>
  <ul>
    <li>
      {/* <div className="info-item">
        <h6 className='custom-font'>VAT Registration No.</h6>
        <span className='custom-data'>{formData.vatRegistrationNumber || Globals.HALF_PAGE_BRIEF_DETAILS.NA}</span>
      </div> */}

      <div className="info-item">
    <h6 className='custom-font'>{Globals.SIGNUP.VENDOR_REQUIRED}</h6>
    <span className='custom-data'>
        {formData.isVendorRegistered ? Globals.SIGNUP.YES : Globals.SIGNUP.NO}
    </span>
</div>
{formData.isVendorRegistered && formData.vendorRegistrationNumber && (
    <div className="info-item">
        <div className='custom-font'>{Globals.SIGNUP.VEN_REG_NUM_LABEL}</div>
        <li className='custom-data'>{formData.vendorRegistrationNumber}</li>
    </div>
)}
<br/>
<br/>
{/** File details when vendor registered as No --- START */}
                  {!formData.isVendorRegistered && !formData.vendorRegistrationNumber && (
                    <>
                      <div className="info-item2">
                        <div className='custom-font'>{Globals.SIGNUP.VENDOR_REG_FILE_UPLOAD_CONTROLS.VAT_CLEARANCE_CERTIFICATE}</div>
                        <div className='profile-file-name-holder profile-user-file'>{taxDetails.name ? <>{isDownloading? <img width={16} height={16} src={Globals.LOADERS.SPINNING_LOADER} style={{ marginRight: "5px", verticalAlign: "middle" }}/>:<img src={Globals.IMG.FILE_ICON} />}<span className="profile-uploaded-file-name profile-user-reg-approval-download-btn profile-user-uploaded-file-name" id="profile-uploaded-file-name" onClick={() => (!isDownloading ?downloadSelectedFile(taxDetails.downloadPath, taxDetails.name,'taxFile'):null)}>{taxDetails.name}</span><img className="profile-user-reg-approval-download-btn" src={Globals.IMG.DOWNLOAD_FILE} style={{ marginLeft: `${marginLeft}px` }} onClick={() => (!isDownloading ?downloadSelectedFile(taxDetails.downloadPath, taxDetails.name, 'taxFile'):null)} /></> : Globals.HALF_PAGE_BRIEF_DETAILS.NA}</div>
                        
                      </div>
                      <div className="info-item2">
                        <div className='custom-font'>{Globals.SIGNUP.VENDOR_REG_FILE_UPLOAD_CONTROLS.VAT_103}</div>
                        <div className='profile-file-name-holder profile-user-file'>{vat103.name ? <>{isDocDownloading.vat103? <img width={16} height={16} src={Globals.LOADERS.SPINNING_LOADER} style={{ marginRight: "5px", verticalAlign: "middle" }}/>:<img src={Globals.IMG.FILE_ICON} />}<span className="profile-uploaded-file-name profile-user-reg-approval-download-btn profile-user-uploaded-file-name" id="profile-uploaded-file-name" onClick={() => (!isDocDownloading.vat103 ?downloadSelectedFile(vat103.downloadPath, vat103.name,'vat103'):null)}>{vat103.name}</span><img className="profile-user-reg-approval-download-btn" src={Globals.IMG.DOWNLOAD_FILE} style={{ marginLeft: `${marginLeft}px` }} onClick={() => (!isDownloading ?downloadSelectedFile(vat103.downloadPath, vat103.name, 'vat103'):null)} /></> : Globals.HALF_PAGE_BRIEF_DETAILS.NA}</div>
                      </div>
                      <div className="info-item2">
                        <div className='custom-font'>{Globals.SIGNUP.VENDOR_REG_FILE_UPLOAD_CONTROLS.TAX_INVOICE}</div>
                        <div className='profile-file-name-holder profile-user-file'>{taxInvoice.name ? <>{isDocDownloading.taxInvoice? <img width={16} height={16} src={Globals.LOADERS.SPINNING_LOADER} style={{ marginRight: "5px", verticalAlign: "middle" }}/>:<img src={Globals.IMG.FILE_ICON} />}<span className="profile-uploaded-file-name profile-user-reg-approval-download-btn profile-user-uploaded-file-name" id="profile-uploaded-file-name" onClick={() => (!isDocDownloading.taxInvoice ?downloadSelectedFile(taxInvoice.downloadPath, taxInvoice.name,'taxInvoice'):null)}>{taxInvoice.name}</span><img className="profile-user-reg-approval-download-btn" src={Globals.IMG.DOWNLOAD_FILE} style={{ marginLeft: `${marginLeft}px` }} onClick={() => (!isDownloading ?downloadSelectedFile(taxInvoice.downloadPath, taxInvoice.name, 'taxInvoice'):null)} /></> : Globals.HALF_PAGE_BRIEF_DETAILS.NA}</div>
                      </div>
                      <br/>
                      <div className="info-item2">
                        <div className='custom-font wrap-white-space-profile'>{Globals.SIGNUP.VENDOR_REG_FILE_UPLOAD_CONTROLS.REG_DOCS}</div>
                        <div className='profile-file-name-holder profile-user-file'>{regDocs.name ? <>{isDocDownloading.regDocs? <img width={16} height={16} src={Globals.LOADERS.SPINNING_LOADER} style={{ marginRight: "5px", verticalAlign: "middle" }}/>:<img src={Globals.IMG.FILE_ICON} />}<span className="profile-uploaded-file-name profile-user-reg-approval-download-btn profile-user-uploaded-file-name" id="profile-uploaded-file-name" onClick={() => (!isDocDownloading.regDocs ?downloadSelectedFile(regDocs.downloadPath, regDocs.name,'regDocs'):null)}>{regDocs.name}</span><img className="profile-user-reg-approval-download-btn" src={Globals.IMG.DOWNLOAD_FILE} style={{ marginLeft: `${marginLeft}px` }} onClick={() => (!isDownloading ?downloadSelectedFile(regDocs.downloadPath, regDocs.name, 'regDocs'):null)} /></> : Globals.HALF_PAGE_BRIEF_DETAILS.NA}</div>
                      </div>
                      
                      {(formData.countryName===Globals.SOUTH_AFRICA || formData.countryName===FallBackLabel.SOUTH_AFRICA )&&<div className="info-item2">
                        <div className='custom-font wrap-white-space-profile'>{Globals.SIGNUP.VENDOR_REG_FILE_UPLOAD_CONTROLS.VALID_BBEEE_CERTIFICATE}</div>
                        <div className='profile-file-name-holder profile-user-file'>{bbbeeeDetails.name ? <>{isBBBEEDownloading? <img width={16} height={16} src={Globals.LOADERS.SPINNING_LOADER} style={{ marginRight: "5px", verticalAlign: "middle" }}/>:<img src={Globals.IMG.FILE_ICON} />}<span className="profile-uploaded-file-name profile-user-reg-approval-download-btn profile-user-uploaded-file-name" id="profile-uploaded-file-name" onClick={() => (!isBBBEEDownloading?downloadSelectedFile(bbbeeeDetails.downloadPath, bbbeeeDetails.name,'bbbeeFile'):null)}>{bbbeeeDetails.name}</span><img id="profile-donwload-btn" className="profile-download-btn profile-user-reg-approval-download-btn" src={Globals.IMG.DOWNLOAD_FILE} style={{ marginLeft: `${marginLeft}px` }} onClick={() => (!isBBBEEDownloading?downloadSelectedFile(bbbeeeDetails.downloadPath, bbbeeeDetails.name,'bbbeeFile'):null)} /></> : Globals.HALF_PAGE_BRIEF_DETAILS.NA}</div>
                      </div>}
                      
                      <div className="info-item2">
                        <div className='custom-font wrap-white-space-profile'>{Globals.SIGNUP.VENDOR_REG_FILE_UPLOAD_CONTROLS.BANK_STAMPED}</div>
                        <div className='profile-file-name-holder profile-user-file'>{bankStamped.name ? <>{isDocDownloading.bankStamped? <img width={16} height={16} src={Globals.LOADERS.SPINNING_LOADER} style={{ marginRight: "5px", verticalAlign: "middle" }}/>:<img src={Globals.IMG.FILE_ICON} />}<span className="profile-uploaded-file-name profile-user-reg-approval-download-btn profile-user-uploaded-file-name" id="profile-uploaded-file-name" onClick={() => (!isDocDownloading.bankStamped ?downloadSelectedFile(bankStamped.downloadPath, bankStamped.name,'bankStamped'):null)}>{bankStamped.name}</span><img className="profile-user-reg-approval-download-btn" src={Globals.IMG.DOWNLOAD_FILE} style={{ marginLeft: `${marginLeft}px` }} onClick={() => (!isDownloading ?downloadSelectedFile(bankStamped.downloadPath, bankStamped.name, 'bankStamped'):null)} /></> : Globals.HALF_PAGE_BRIEF_DETAILS.NA}</div>
                      </div>
                    </>
                  )}
{/** File details when vendor registered as No --- END */}

    {/*<div className="info-item">
  <h6 className='custom-font'>Tax Clearance certificate/Pin <br />Available?</h6>
  <ul>
    {formData.isTaxClearanceCertificate ? (
      <li>
        <span className='custom-data' style={{ display: 'inline-block', marginRight: '5px' }}>Yes</span>
      </li>
    ) : (
      <li className='custom-data'>No</li>
    )}
  </ul>
</div>
  {formData.isTaxClearanceCertificate && (
  <div className="inner-doc">
    <h6 className='custom-font' style={{ margin: 0 }}>Tax Clearance certificate/Pin</h6>
                      { <ul className='doc-download' style={{ margin: 0, padding: 0 }}>
                        <li style={{ display: 'flex', alignItems: 'center' }}>
                          <img
                            src={Globals.IMG.DOCUMENT}
                            alt="Document"
                            style={{ margin: '0px 2px 0px 0px' }}
                          />
                          <span className='docname' onClick={() => downloadSelectedFile(taxDetails.downloadPath, taxDetails.name)} style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', direction: 'rtl', maxWidth: '22ch' }}>
                            {taxDetails.name}
                          </span>
                          <span onClick={() => downloadSelectedFile(taxDetails.downloadPath, taxDetails.name)} style={{ marginLeft: '55px', minWidth: '55px', display: 'inline-flex', justifyContent: 'center' }}>
                            <img src={Globals.IMG.DOWNLOAD} className='download-profile' alt="Download" />
                          </span>
                        </li>
                      </ul> }
                      <div className='profile-file-name-holder profile-user-file'>{taxDetails.name ? <>{isDownloading? <img width={16} height={16} src={Globals.LOADERS.SPINNING_LOADER} style={{ marginRight: "5px", verticalAlign: "middle" }}/>:<img src={Globals.IMG.FILE_ICON} />}<span className="profile-uploaded-file-name profile-user-reg-approval-download-btn profile-user-uploaded-file-name" id="profile-uploaded-file-name" onClick={() => (!isDownloading ?downloadSelectedFile(taxDetails.downloadPath, taxDetails.name,'taxFile'):null)}>{taxDetails.name}</span><img className="profile-user-reg-approval-download-btn" src={Globals.IMG.DOWNLOAD_FILE} style={{ marginLeft: `${marginLeft}px` }} onClick={() => (!isDownloading ?downloadSelectedFile(taxDetails.downloadPath, taxDetails.name, 'taxFile'):null)} /></> : Globals.HALF_PAGE_BRIEF_DETAILS.NA}</div>
  </div>
  )}
*/}

<li>
  
{/*<div className="info-item">
  <h6 className='custom-font'>B-BBEE Compliant?</h6>
  <ul>
    {formData.isBBBEE ? (
      <li>
      <span className='custom-data' style={{ display: 'inline-block', marginRight: '5px' }}>Yes</span>
    </li>
    ) : (
      <li className='custom-data'>No</li>
    )}
  </ul>
</div>
{formData.isBBBEE && (
                      <div className="inner-doc">
                        <h6 className='custom-font' style={{ margin: 0 }}>B-BBEE Certificate</h6>
                        <ul className='doc-download' style={{ margin: 0, padding: 0 }}>
                        <div className='profile-file-name-holder profile-user-file'>{bbbeeeDetails.name ? <>{isBBBEEDownloading? <img width={16} height={16} src={Globals.LOADERS.SPINNING_LOADER} style={{ marginRight: "5px", verticalAlign: "middle" }}/>:<img src={Globals.IMG.FILE_ICON} />}<span className="profile-uploaded-file-name profile-user-reg-approval-download-btn profile-user-uploaded-file-name" id="profile-uploaded-file-name" onClick={() => (!isBBBEEDownloading?downloadSelectedFile(bbbeeeDetails.downloadPath, bbbeeeDetails.name,'bbbeeFile'):null)}>{bbbeeeDetails.name}</span><img id="profile-donwload-btn" className="profile-download-btn profile-user-reg-approval-download-btn" src={Globals.IMG.DOWNLOAD_FILE} style={{ marginLeft: `${marginLeft}px` }} onClick={() => (!isBBBEEDownloading?downloadSelectedFile(bbbeeeDetails.downloadPath, bbbeeeDetails.name,'bbbeeFile'):null)} /></> : Globals.HALF_PAGE_BRIEF_DETAILS.NA}</div>      
                          { <li style={{ display: 'flex', alignItems: 'center' }}>
                            <img
                              src={Globals.IMG.DOCUMENT}
                              alt="Document"
                              style={{ margin: '0px 2px 0px 0px' }}
                            />
                            <span className='docname' onClick={() => downloadSelectedFile(bbbeeeDetails.downloadPath, bbbeeeDetails.name)} style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', direction: 'rtl', maxWidth: '20ch' }}>
                              {bbbeeeDetails.name}
                            </span>
                            <span onClick={() => downloadSelectedFile(bbbeeeDetails.downloadPath, bbbeeeDetails.name)} style={{ marginLeft: '80px', minWidth: '80px', display: 'inline-flex', justifyContent: 'center' }}>
                              <img src={Globals.IMG.DOWNLOAD} className='download-profile' alt="Download" />
                            </span>
                          </li> }
                        </ul>
                      </div>
  
      )}
      </ul>
      */}
</li>
        

    </li>
  </ul>
</div> <hr style={{ margin: '24px 24px 24px 0px'}} />
<div className="contact-info">
  <h5 className="custom-margin">{Globals.SIGNUP.COMPANY_INFO}</h5>
  <ul>
    <li>
      <div className="info-item">
        <h6 className='custom-font'>{Globals.SIGNUP.COMPANY_CONTACT_NUM_LABEL}</h6>
        <span className='custom-data'>{formData.companyContactNumber|| Globals.HALF_PAGE_BRIEF_DETAILS.NA}</span>
      </div>

      <div className="info-item">
        <h6 className='custom-font'>{Globals.SIGNUP.COMPANY_EMAIL_LABEL}</h6>
        <span className='custom-data'>{formData.companyEmail|| Globals.HALF_PAGE_BRIEF_DETAILS.NA}</span>
      </div>

      <div className="info-item">
        <h6 className='custom-font'>{Globals.SIGNUP.COMPANY_ADDRESS}</h6>
        <span className='custom-font-address'>{formData.businessAddress|| Globals.HALF_PAGE_BRIEF_DETAILS.NA}</span>
      </div>
      <div className="info-item">
        <h6 className='custom-font'>{Globals.SIGNUP.COUNTRY}</h6>
        <span className='custom-data'>{formData.countryName || Globals.HALF_PAGE_BRIEF_DETAILS.NA}</span>
      </div>
      
      <div className="info-item">
        <h6 className='custom-font' >{Globals.SIGNUP.PROVIENCE}</h6>
        <span className='custom-data'>{formData.provinceName || Globals.HALF_PAGE_BRIEF_DETAILS.NA}</span>
      </div>
    </li>

  </ul>
</div></div>
    </div></div>
    <Footer />
    <div>
            {showSuccessToast && (
                <Toast
                    status = "info"
                    onClose={handleToastClose}
                    title={Globals.PROFILE_UPDATED_SUCCESS}
                />
            )}
        </div>
    </div>
  );
}

export default CompanyProfile;